import React, { useState } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import "../../assets/css/style.scss";
import aboutBanner from "../../assets/images/about-bg.jpg"


const Aboutus = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="image-box-container" style={{ backgroundImage: `url(${aboutBanner})` }}>
                    <div className="overlay-colored-Bg"></div>
                    <div className="container">
                        <div className="center-content">
                            <div className="banner-title">
                                <h1>Cancellation & Refund Policy</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="pt-0 py-md-5 mt-md-5 mb-4 about-center-content">
                    <div className="container">
                        <div className="row panel-grid panel-no-style px-lg-5">

                            <div className="col-12 col-xl-12">
                                <div className="m-xl-5 px-3 px-md-0">
                                    <div className="notice_title">
                                        <h2 className="small-title--mt mb-3">~ Cancellation & Refund Policy  ~</h2>
                                        <p>
                                            <b>
                                                Updated at 10-11-2023
                                            </b>
                                        </p>
                                    </div>

                                    <p class="mt-3">
                                        <div class="abt_offr">Order Cancellation: </div>
                                        Cancellation Period: You may cancel an order within 1 hour of placing it for a full refund. <br></br>
                                        Cancellation Process: To cancel an order, please contact our customer support with your order details.<br></br>
                                        Cancelled Orders after Dispatch: Once an order has been dispatched, it cannot be canceled. However, you may return the item(s) following our return policy (see below).
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Return Policy: </div>
                                        Eligibility for Returns: If you are not satisfied with your purchase, you may return the item(s) within 24 hrs from the date of delivery. <br></br>
                                        Return Process: To initiate a return, please contact our customer support team for instructions. The item(s) must be unused, undamaged, in the original packaging, and accompanied by the receipt or proof of purchase. <br></br>

                                        Return Shipping: Customers are responsible for return shipping costs unless the return is due to a defect or error on our part.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Refund Policy: </div>
                                        Eligibility for Refund: Refunds are issued if the cancellation is made within the specified time frame and adheres to our cancellation policy.
                                        Refund Processing Time: Refunds will be processed within 7 days after the cancellation request is approved. Please note that it may take additional time for the refunded amount to reflect in your account, depending on your bank or payment provider.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Policy Changes: </div>
                                        we reserves the right to modify or update this Cancellation & Refund Policy at any time. 
                                        Changes will be effective upon posting on our website. Please review this policy periodically for any updates.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    )
}
export default Aboutus;